import { Column } from 'primereact/column'
import { Fieldset } from 'primereact/fieldset'
import React, { useEffect } from 'react'
import { FiDownload } from 'react-icons/fi'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import {
  Btn,
  CustomCheckbox,
  CustomDataTableHeader,
  CustomDropdown,
  CustomPanel,
  CustomRadioButton,
  InputText,
  NumeroDecimal,
  PageHeader,
  ThreeDots,
  CustomDataTable,
} from '../../../../components'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import ModalEan from './ModalEan/ModalEan'
import ModalProduto from './ModalProduto'
import './Produto.css'
import useProdutoHook, { BARCODE_TYPES, LOAD_MESSAGE } from './ProdutoHook'

function Produto({ dispatch, history, selectedTp }) {
  const { state, localDispatch } = useProdutoHook()

  useEffect(() => {
    localDispatch.onInit()
  }, [selectedTp])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break

      case LOAD_MESSAGE.GET_PRODUCTS:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.getProdutos(state.selectedEmpresa)
        break

      case LOAD_MESSAGE.SEARCH_PRODUCTS:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        break

      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  const barcodeItems = [
    { value: BARCODE_TYPES.PRODUCT_CODE, label: 'Código do Produto' },
    { value: BARCODE_TYPES.EAN, label: 'Por EAN' },
  ]

  return (
    <div>
      <PageHeader>2.2 - Produtos</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel
          onNovo={() => localDispatch.onBtnNovo(state.selectedEmpresa)}
          onVoltar={history.goBack}
        >
          <div className="p-grid p-align-center">
            <form style={{ width: 300 }} className="p-md-4 p-col-12">
              <CustomDropdown
                filter={true}
                optionLabel="name"
                options={state.empresas}
                value={state.selectedEmpresa}
                label="Empresa :"
                onChange={value => localDispatch.onEmpresaChange(value)}
              />
            </form>
            <div className="p-md-2 p-col-12 product-export-button">
              <Btn onClick={() => localDispatch.getProdutosExported(state.selectedEmpresa)}>
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <FiDownload size={18} />
                  <span style={{ marginLeft: 5 }}>Exportar</span>
                </div>
              </Btn>
            </div>
            <div className="p-md-6 p-col-12 product-barcode-generator">
              <span className="product-barcode-label">Gerar Códigos de Barras:</span>
              <CustomRadioButton
                items={barcodeItems}
                value={state.barcodeType}
                onChange={value => localDispatch.onBarcodeTypeChange(value)}
                labelColor="#14B0BF"
                labelFontSize="0.8rem"
              />
              <Btn disabled={!state.selectedEmpresa} onClick={localDispatch.onGerarCodigosBarras}>
                Gerar
              </Btn>
            </div>

            <Fieldset
              legend="Filtro"
              toggleable
              collapsed={true}
              className="p-col-12"
              style={{ marginTop: 20 }}
            >
              <div className="p-grid p-align-center">
                <div className="p-col-4">
                  <InputText
                    label="Código de Barras"
                    value={state.codigoBarras}
                    onChange={v => localDispatch.onFilterChange('codigoBarras', v)}
                  />
                </div>
                <div className="p-col-1" style={{ marginTop: 32 }}>
                  <Btn onClick={localDispatch.onBuscarFiltrado}>Buscar</Btn>
                </div>
                <div className="p-col-1" style={{ marginTop: 32 }}>
                  <Btn onClick={localDispatch.onLimparFiltro}>Limpar Filtro</Btn>
                </div>
              </div>
            </Fieldset>
          </div>
          <CustomDataTable
            style={{ marginTop: 15 }}
            value={state.produtos}
            paginator={true}
            rows={10}
            emptyMessage={'Sem produtos para exibir'}
            header={
              <CustomDataTableHeader
                onChange={value => localDispatch.onGlobalFilterChange(value)}
              />
            }
            globalFilter={state.globalFilter}
            responsive={true}
          >
            <Column
              field="product_code"
              header="Código"
              className="product-info-column product-info-column-w150"
            />
            <Column field="name" header="Produto" />
            <Column
              field="weight"
              header="Peso Bruto por Caixa/Volume"
              body={produto => <NumeroDecimal>{produto.weight}</NumeroDecimal>}
              className="product-info-column product-info-column-w130"
            />
            <Column
              field="unit_sku"
              header="Unidade por SKU"
              className="product-info-column product-info-column-w150"
            />
            <Column
              field="m3"
              header="Volume (m3)"
              body={produto => <NumeroDecimal decimalScale={4}>{produto.m3}</NumeroDecimal>}
              className="product-info-column product-info-column-w130 column-mobile-hidden"
            />
            <Column
              field="ordem_separacao"
              header="Ordem"
              className="product-info-column product-info-column-w100 column-mobile-hidden"
            />
            <Column
              field="actived"
              header="Ativo"
              className="product-info-column product-info-column-w100 column-mobile-hidden"
              body={produto => <CustomCheckbox disabled checked={produto.actived} />}
            />
            <Column
              header="Menu"
              className="product-info-column product-info-column-w80"
              body={produto => (
                <ThreeDots
                  items={localDispatch.getMenuItems()}
                  onClick={menuItem => localDispatch.onThreeDotsClicked(menuItem, produto)}
                />
              )}
            />
          </CustomDataTable>
        </CustomPanel>
      </div>
      <ModalProduto
        show={state.modalProduto.show}
        onModalClose={localDispatch.onModalProdutoClose}
        onModalSave={localDispatch.onModalProdutoSave}
        data={state.modalProduto.data}
        grupos={state.grupos}
        empresas={state.empresas}
        selectedTp={selectedTp}
      />
      <ModalEan
        show={state.modalEan.show}
        onModalClose={localDispatch.onModalEanClose}
        data={state.modalEan.data}
      />
    </div>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(withRouter(Produto))
